/**
 * DOJA COOKIES — DELIVERY & PICKUP CONFIG
 * ---------------------------------------
 * Edit this file to manage the customer choices, blackout dates,
 * and pickup-related date constraints. After saving, refresh to apply.
 *
 * Shipping rates are configured natively in Shopify admin →
 * Settings → Shipping & Delivery → per zone. The delivery picker
 * writes the customer's chosen zone + date to cart attributes
 * (delivery_choice, delivery_date, delivery_date_pretty, pickup_address)
 * so they show up under the order's "Additional details" in admin and
 * in any Zapier/Flow/webhook automation (the delivery bot reads these).
 * It does NOT write line-item properties — see the note in
 * delivery-picker.js for why.
 *
 * Pickup orders are routed through /discount/DOJA_PICKUP?redirect=/checkout
 * so the free-shipping discount applies. Make sure that discount code exists
 * in Shopify admin → Discounts.
 */
// Pull editable zone sub-text from theme settings (set in layout/theme.liquid).
// Falls back to the hard-coded default if a setting is empty.
(function () {
  const SUBS = (typeof window !== 'undefined' && window.DOJA_ZONE_SUBS) || {};
  window.__doja_sub = function (id, fallback) {
    const v = SUBS[id];
    return (v && String(v).trim()) || fallback;
  };
})();

window.DOJA_DELIVERY_CONFIG = {

  /* ===== CUSTOMER CHOICES ========================================
   * available_days uses numbers:
   * 0=Sun  1=Mon  2=Tue  3=Wed  4=Thu  5=Fri  6=Sat
   * sub-text is editable from theme settings → Doja Delivery.
   *
   * NO zone is pre-selected. The customer must tap one before any
   * date appears, so the chosen date always matches the zone they
   * actually picked. Pre-selecting East Cairo (daily) let Giza / 6
   * October customers who never touched the pills book a weekday date
   * for a Sundays-only area — see order 001-1907. Do not add a
   * `default` flag back here.
   * ============================================================= */
  choices: [
    {
      id: 'east_cairo_delivery',
      label: 'East Cairo Delivery',
      sub:   window.__doja_sub('east_cairo_delivery', 'Tagamo3, Heliopolis, Nasr City · daily'),
      kind: 'delivery',
      available_days: [0, 1, 2, 3, 4, 5, 6],
    },
    {
      // Maadi moved here from East Cairo on 2026-07-12 — it is Sundays-only now,
      // same as Giza / 6 October / Sheikh Zayed. Keep the id as-is: existing carts
      // and the Telegram delivery bot both key off `west_cairo_delivery`.
      id: 'west_cairo_delivery',
      label: 'West',
      sub:   window.__doja_sub('west_cairo_delivery', 'Giza, 6 October, Sheikh Zayed, Maadi · Sundays only · book at least 1 day ahead'),
      kind: 'delivery',
      available_days: [0],
    },
    {
      id: 'pickup_cairo',
      label: 'Pickup',
      sub:   window.__doja_sub('pickup_cairo', 'Obour City · 1pm – 8pm daily'),
      kind: 'pickup',
      pickupAddress: 'Gamaiet Ahmed Orabi, Obour City, Cairo',
      pickupMapsUrl: 'https://maps.app.goo.gl/fLZBZhJMr6km2J5T8',
      available_days: [0, 1, 2, 3, 4, 5, 6],
    },
  ],

  deliver_on_fridays: (typeof window !== 'undefined' && typeof window.DOJA_DELIVER_ON_FRIDAYS !== 'undefined') ? window.DOJA_DELIVER_ON_FRIDAYS : true,
  min_delivery_lead_days: 1,
  max_delivery_days_ahead: 60,

  /* ===== BLACKOUT DATES ==========================================
   * Pulled from theme setting "Doja Delivery → Blackout dates"
   * (one date per line, YYYY-MM-DD format).
   * Lines starting with # are ignored. YYYY/MM/DD and YYYY.MM.DD
   * are accepted and normalised to YYYY-MM-DD. The parser is
   * deliberately forgiving because these are typed by hand.
   *
   * Calendar pickers were built twice (metaobject, then a list.date
   * shop metafield) and rejected both times: Shopify theme settings
   * have no date input type, so any calendar has to live on a
   * different admin page, which the user does not want. Plain typing
   * here is the decision. Do not re-introduce a calendar.
   * ============================================================= */
  blackout_dates: (function () {
    const fromAdmin = (typeof window !== 'undefined' && window.DOJA_BLACKOUT_DATES_FROM_ADMIN) || '';
    const out = [];
    fromAdmin.split(/\r?\n/).forEach(raw => {
      const line = (raw || '').replace(/[\u200B-\u200D\uFEFF]/g, '').trim();
      if (!line || line.charAt(0) === '#') return;
      const m = line.match(/(\d{4})[-\/.](\d{1,2})[-\/.](\d{1,2})/);
      if (!m) return;
      const iso = `${m[1]}-${m[2].padStart(2, '0')}-${m[3].padStart(2, '0')}`;
      if (out.indexOf(iso) === -1) out.push(iso);
    });
    if (typeof console !== 'undefined' && out.length) {
      console.info('[Doja Delivery] blackout dates loaded:', out);
    }
    return out;
  })(),

  blackout_note: (typeof window !== 'undefined' && window.DOJA_BLACKOUT_NOTE) || "We're closed on this date — please pick another day.",

  pickup: {
    hours_start: 13,
    hours_end: 20,
    min_lead_time_hours: 2,
    max_days_ahead: 60,
  },

  pickup_discount_code: 'DOJA_PICKUP',
};
